interface DividerCategory {
    id: string;
    term: string;
    definition: string;
}

interface DividerCategoryGroup {
    label: string;
    categories: DividerCategory[];
}

export const DIVIDER_CATEGORY_GROUPS: DividerCategoryGroup[] = [
    {
        label: 'Inteligência',
        categories: [
            {
                id: 'inteligencia-geral',
                term: 'Inteligência geral',
                definition:
                    'Capacidade global de raciocinar, resolver problemas, aprender com experiências e adaptar-se a novas situações.',
            },
            {
                id: 'indice-compreensao-verbal',
                term: 'Índice de compreensão verbal',
                definition:
                    'Habilidade de compreender, utilizar e pensar com palavras, incluindo vocabulário e expressão verbal.',
            },
            {
                id: 'indice-organizacao-perceptual',
                term: 'Índice de organização perceptual',
                definition:
                    'Capacidade de perceber, analisar e organizar informações visuais e relações espaciais.',
            },
        ],
    },
    {
        label: 'Memória',
        categories: [
            {
                id: 'indice-memoria-operacional',
                term: 'Índice de memória operacional',
                definition:
                    'Habilidade de manter e manipular informações temporariamente para realizar tarefas complexas.',
            },
            {
                id: 'memoria-operacional',
                term: 'Memória operacional',
                definition:
                    'Manutenção e manipulação temporária de informações para tarefas cognitivas.',
            },
            {
                id: 'memoria-curto-prazo',
                term: 'Memória de curto prazo',
                definition: 'Retenção de informações por um breve período sem manipulação ativa.',
            },
            {
                id: 'memoria-longo-prazo',
                term: 'Memória de longo prazo',
                definition: 'Armazenamento duradouro de informações ao longo do tempo.',
            },
            {
                id: 'memoria-declarativa-episodica',
                term: 'Memória declarativa episódica',
                definition:
                    'Capacidade de recordar eventos e experiências pessoais situadas no tempo e espaço.',
            },
            {
                id: 'memoria-declarativa-semantica',
                term: 'Memória declarativa semântica',
                definition:
                    'Armazenamento e recuperação de conhecimentos gerais e fatos sobre o mundo.',
            },
        ],
    },
    {
        label: 'Atenção',
        categories: [
            {
                id: 'atencao-sustentada',
                term: 'Atenção sustentada',
                definition: 'Capacidade de manter o foco por um período prolongado.',
            },
            {
                id: 'atencao-dividida',
                term: 'Atenção dividida',
                definition:
                    'Capacidade de dividir a atenção entre múltiplas tarefas simultaneamente.',
            },
            {
                id: 'atencao-focalizada',
                term: 'Atenção focalizada',
                definition: 'Habilidade de direcionar e manter atenção em um estímulo específico.',
            },
            {
                id: 'atencao-alternada',
                term: 'Atenção alternada',
                definition: 'Capacidade de alternar o foco entre diferentes tarefas.',
            },
        ],
    },
    {
        label: 'Funções Executivas',
        categories: [
            {
                id: 'funcoes-executivas',
                term: 'Funções executivas',
                definition:
                    'Processos mentais ligados ao planejamento, organização, tomada de decisões e controle de impulsos.',
            },
            {
                id: 'controle-inibitorio',
                term: 'Controle inibitório',
                definition: 'Capacidade de controlar impulsos e resistir a distrações.',
            },
            {
                id: 'flexibilidade-cognitiva',
                term: 'Flexibilidade cognitiva',
                definition: 'Capacidade de adaptar pensamento e comportamento diante de mudanças.',
            },
            {
                id: 'planejamento',
                term: 'Planejamento',
                definition:
                    'Capacidade de estabelecer objetivos e organizar ações para alcançá-los.',
            },
            {
                id: 'solucao-problemas',
                term: 'Solução de problemas',
                definition: 'Processo de identificar e resolver situações novas ou desafiadoras.',
            },
        ],
    },
    {
        label: 'Velocidade de Processamento',
        categories: [
            {
                id: 'indice-velocidade-processamento',
                term: 'Índice de velocidade de processamento',
                definition:
                    'Rapidez e precisão ao perceber, processar e responder a estímulos simples.',
            },
        ],
    },
    {
        label: 'Interferência',
        categories: [
            {
                id: 'interferencia-proativa',
                term: 'Interferência proativa',
                definition: 'Informações antigas dificultam a aprendizagem de novas.',
            },
            {
                id: 'interferencia-retroativa',
                term: 'Interferência retroativa',
                definition: 'Informações novas dificultam a lembrança de informações antigas.',
            },
        ],
    },
    {
        label: 'Percepção e Motricidade',
        categories: [
            {
                id: 'percepcao-visuoespacial',
                term: 'Percepção visuoespacial',
                definition: 'Capacidade de compreender relações espaciais entre objetos.',
            },
            {
                id: 'motricidade-fina',
                term: 'Motricidade fina',
                definition: 'Movimentos precisos com mãos e dedos.',
            },
            {
                id: 'motricidade-grossa',
                term: 'Motricidade grossa',
                definition: 'Coordenação de grandes grupos musculares para movimentos amplos.',
            },
            {
                id: 'praxias',
                term: 'Praxias',
                definition: 'Planejamento e execução de movimentos voluntários coordenados.',
            },
        ],
    },
    {
        label: 'Linguagem',
        categories: [
            {
                id: 'linguagem',
                term: 'Linguagem',
                definition: 'Sistema de comunicação por palavras faladas, escritas ou gestuais.',
            },
            {
                id: 'pragmatica-linguagem',
                term: 'Pragmática da linguagem',
                definition: 'Uso social da linguagem conforme o contexto.',
            },
            {
                id: 'semantica',
                term: 'Semântica',
                definition: 'Significado das palavras e frases.',
            },
            {
                id: 'sintaxe',
                term: 'Sintaxe',
                definition: 'Regras que organizam palavras em frases.',
            },
            {
                id: 'aspectos-fonologicos',
                term: 'Aspectos fonológicos da linguagem',
                definition: 'Percepção e manipulação dos sons da fala.',
            },
            {
                id: 'consciencia-fonologica',
                term: 'Consciência fonológica',
                definition: 'Capacidade de identificar e manipular sons das palavras.',
            },
        ],
    },
    {
        label: 'Senso Numérico',
        categories: [
            {
                id: 'senso-numerico',
                term: 'Senso numérico',
                definition: 'Compreensão e manipulação de números e quantidades.',
            },
        ],
    },
    {
        label: 'Aspectos Emocionais e Personalidade',
        categories: [
            {
                id: 'sintomas-internalizantes',
                term: 'Sintomas internalizantes',
                definition:
                    'Dificuldades emocionais voltadas para o interior, como ansiedade e depressão.',
            },
            {
                id: 'sintomas-externalizantes',
                term: 'Sintomas externalizantes',
                definition: 'Comportamentos observáveis como impulsividade e agressividade.',
            },
            {
                id: 'personalidade',
                term: 'Personalidade',
                definition: 'Padrões consistentes de pensamento, sentimento e comportamento.',
            },
            {
                id: 'neuroticismo',
                term: 'Neuroticismo',
                definition: 'Tendência a emoções negativas e instabilidade emocional.',
            },
            {
                id: 'extroversao',
                term: 'Extroversão',
                definition: 'Tendência à sociabilidade e busca por interação.',
            },
            {
                id: 'abertura',
                term: 'Abertura',
                definition: 'Curiosidade e interesse por novas experiências.',
            },
            {
                id: 'amabilidade',
                term: 'Amabilidade',
                definition: 'Tendência a ser cooperativo e gentil.',
            },
            {
                id: 'conscienciosidade',
                term: 'Conscienciosidade',
                definition: 'Organização, responsabilidade e autodisciplina.',
            },
        ],
    },
];
